import React from "react";
import SignupForm from "../../SignupForm";
import ShareBar from "../../ShareBar";
import { SOCIALS } from "../../socials";

function SocialLinks() {
  return (
    <div className="mt-10">
      <div className="eyebrow mb-3">Follow the signal</div>
      <div className="flex flex-wrap gap-3" data-testid="home-social-links">
        {SOCIALS.map(({ key, label, href, icon: Icon }) => (
          <a
            key={key}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ghost"
            data-testid={`home-social-${key}`}
          >
            <Icon size={14} />
            <span>{label}</span>
          </a>
        ))}
      </div>
    </div>
  );
}

export default function SignupSection() {
  return (
    <section
      id="signup"
      className="border-b-2 border-current"
      data-testid="signup-section"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-24 grid gap-14 md:grid-cols-[1fr_1.2fr] items-start">
        <div>
          <div className="eyebrow mb-4">Join the awakening</div>
          <h2 className="font-display uppercase font-bold text-5xl md:text-7xl leading-[0.9] tracking-tight">
            Be<br />the next<br />monkey.
          </h2>
          <p className="font-body mt-6 text-lg leading-relaxed opacity-90 max-w-md">
            Sign up to NewWaysToday and we'll let you know when the next
            dispatches drop — essays, archive finds, peace-action calls.
            One email at a time. You can stop at any time.
          </p>
          <div className="mt-8">
            <ShareBar title="The Hundredth Monkey" />
          </div>
          <SocialLinks />
          <div className="mt-10 hidden md:block border-2 border-current overflow-hidden max-w-sm">
            <img
              src="/images/monkey-poster.jpg"
              alt="The Hundredth Monkey — activist poster, NewWaysToday edition"
              className="w-full object-cover"
              loading="lazy"
              data-testid="home-monkey-poster"
            />
            <div className="border-t-2 border-current px-3 py-2 font-display uppercase tracking-widest text-[0.65rem] opacity-80">
              NewWaysToday edition poster
            </div>
          </div>
        </div>
        <div
          className="border-2 border-current bg-[hsl(var(--card))] p-7 md:p-10"
          style={{ boxShadow: "8px 8px 0 0 hsl(var(--primary))" }}
        >
          <SignupForm />
        </div>
      </div>
    </section>
  );
}
